import { waterFillingMachines, roPlants, auxiliaryMachines } from '../mock/mockData';
import { solutionProducts } from './solutionProducts';

export const allProducts = [...waterFillingMachines, ...roPlants, ...auxiliaryMachines, ...solutionProducts];

export const findProductBySlug = (slug) => allProducts.find((p) => p.slug === slug);

export const categoryOf = (id) => {
  if (id.startsWith('wfm') || id.startsWith('bm-')) return 'bottling';
  if (id.startsWith('ro') || id.startsWith('wt-')) return 'water-treatment';
  if (id.startsWith('pk-')) return 'packaging';
  if (id.startsWith('bev-')) return 'beverage';
  if (id.startsWith('bmf-')) return 'bottle-manufacturing';
  return 'aux';
};
